(function () {
  function getCount() { var el = document.getElementById('hc-product-count'); return el ? el.getAttribute('data-count') : null; }

  function moveSort() {
    var sel = document.getElementById('SortBy');
    var form = document.querySelector('#CollectionSidebar .filter-form');
    if (!sel || !form) return;
    var cell = sel.closest('.grid__item') || sel.parentElement;
    if (cell && cell.parentElement !== form) { cell.classList.add('hc-sort-cell'); form.appendChild(cell); }
    var lbl = form.querySelector('.hc-sort-cell label[for="SortBy"]');
    if (lbl && lbl.textContent.trim() !== 'Sort') lbl.textContent = 'Sort';
  }

  function showSelections() {
    var sb = document.getElementById('CollectionSidebar'); if (!sb) return;
    [].forEach.call(sb.querySelectorAll('.collection-sidebar__group'), function (g) {
      var trig = g.querySelector('.collapsible-trigger-btn'); if (!trig) return;
      var vals = [];
      [].forEach.call(g.querySelectorAll('input:checked'), function (cb) {
        var lbl = cb.closest('label') || cb.parentElement;
        var t = (lbl.textContent || '').replace(/\(\d[\d,]*\)/, '').replace(/\s+/g, ' ').trim();
        if (t) vals.push(t);
      });
      var gte = g.querySelector('input[name*="price.gte"]'), lte = g.querySelector('input[name*="price.lte"]');
      var price = ((gte && gte.value) || (lte && lte.value)) ? '$' + ((gte && gte.value) || '0') + '–$' + ((lte && lte.value) || '∞') : null;
      var count = vals.length + (price ? 1 : 0);
      var span = trig.querySelector('.hc-selected');
      if (count === 0) { if (span) span.parentNode.removeChild(span); return; }
      if (!span) { span = document.createElement('span'); span.className = 'hc-selected'; var icon = trig.querySelector('.collapsible-trigger__icon'); if (icon) trig.insertBefore(span, icon); else trig.appendChild(span); }
      var mode = count === 1 ? 'text' : 'count';
      var text = count === 1 ? (vals[0] || price) : String(count);
      if (span.getAttribute('data-mode') !== mode || span.textContent !== text) { span.setAttribute('data-mode', mode); span.className = 'hc-selected ' + (mode === 'count' ? 'hc-selected--count' : 'hc-selected--text'); span.textContent = text; }
    });
  }

  function ensureDesktopCount() {
    var form = document.querySelector('#CollectionSidebar .filter-form'); if (!form) return;
    var n = getCount();
    var el = document.getElementById('hc-desktop-count');
    if (n == null) { if (el) el.remove(); form.classList.remove('hc-has-count'); return; }
    if (!el) { el = document.createElement('span'); el.id = 'hc-desktop-count'; el.className = 'hc-desktop-count'; var sc = form.querySelector('.hc-sort-cell'); if (sc) form.insertBefore(el, sc); else form.appendChild(el); }
    form.classList.add('hc-has-count');
    var txt = n + ' ' + (n === '1' ? 'item' : 'items');
    if (el.textContent !== txt) el.textContent = txt;
  }

  function ensureViewResults() {
    var drawer = document.getElementById('FilterDrawer'); if (!drawer) return;
    var contents = drawer.querySelector('.drawer__contents'); if (!contents) return;
    var btn = document.getElementById('hc-view-results');
    if (!btn) { btn = document.createElement('button'); btn.id = 'hc-view-results'; btn.type = 'button'; btn.addEventListener('click', function () { var c = drawer.querySelector('.js-drawer-close'); if (c) c.click(); }); }
    if (btn.parentElement !== contents) contents.appendChild(btn);
    var n = getCount();
    btn.textContent = (n != null) ? ('See ' + n + ' ' + (n === '1' ? 'Item' : 'Items')) : 'View Results';
  }

  function apply() { moveSort(); showSelections(); ensureDesktopCount(); ensureViewResults(); }

  var raf = null;
  function sched() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; apply(); }); }

  function init() { apply(); if (!window.__hcObs) { window.__hcObs = new MutationObserver(sched); window.__hcObs.observe(document.body, { childList: true, subtree: true }); } }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Desktop: one dropdown open at a time + click-outside to close
  if (!window.__hcFilterBound) {
    window.__hcFilterBound = true;
    var desk = function () { return matchMedia('(min-width:769px)').matches; };
    var sb = function () { return document.getElementById('CollectionSidebar'); };
    var lock = false, lastTrig = null;
    document.addEventListener('click', function (e) {
      var b = sb(); if (!b) return;
      var trig = e.target.closest('.collapsible-trigger-btn');
      if (trig && b.contains(trig)) {
        if (!desk() || lock) return;
        lastTrig = trig;
        setTimeout(function () { if (lock) return; if (lastTrig && lastTrig.classList.contains('is-open')) { lock = true; b.querySelectorAll('.collapsible-trigger-btn.is-open').forEach(function (t) { if (t !== lastTrig) t.click(); }); lock = false; } }, 0);
        return;
      }
      if (desk() && !b.contains(e.target)) { var open = b.querySelectorAll('.collapsible-trigger-btn.is-open'); if (open.length) { lock = true; open.forEach(function (t) { t.click(); }); lock = false; } }
    }, true);
  }

  // Mobile: expand all sections when the drawer opens
  if (!window.__hcExpandBound) {
    window.__hcExpandBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('#FilterDrawerTrigger')) {
        setTimeout(function () { if (matchMedia('(max-width:768px)').matches) { document.querySelectorAll('#FilterDrawer .collapsible-trigger-btn:not(.is-open)').forEach(function (t) { t.click(); }); } }, 80);
      }
    }, true);
  }

  // Close any open desktop dropdowns when crossing from mobile to desktop width
  if (!window.__hcResizeBound) {
    window.__hcResizeBound = true;
    var wasDesk = matchMedia('(min-width:769px)').matches;
    window.addEventListener('resize', function () {
      var isDesk = matchMedia('(min-width:769px)').matches;
      if (isDesk && !wasDesk) { document.querySelectorAll('#CollectionSidebar .collapsible-trigger-btn.is-open').forEach(function (t) { t.click(); }); }
      wasDesk = isDesk;
    });
  }
})();
/* Collection CTA tile: rendered once as a sibling outside the product grid.
   With infinite scroll we must NOT drop it in after the first page — otherwise it
   re-pins to the end of every partial batch and keeps re-appearing mid-collection
   as the shopper scrolls. Instead, hold it hidden until the LAST page has loaded
   (#more-link gone), then place it as the final cell so it appears exactly once,
   at the true end of the products. Pagination mode / single page: show immediately. */
(function () {
  function initCtaTile() {
    var tile = document.querySelector('.cc-cta-item[data-cc-cta-pending]');
    if (!tile) return;
    var grid = document.querySelector('#CollectionAjaxContent .grid--uniform')
            || document.querySelector('.grid--uniform');
    if (!grid) return;
    tile.removeAttribute('data-cc-cta-pending');

    function morePages() { return !!document.querySelector('#more-link'); }
    function pin() { if (tile.parentNode !== grid || tile !== grid.lastElementChild) grid.appendChild(tile); }
    function endPin() {
      // Once it's in place, keep it last if anything else (e.g. Depict cards) mutates the grid.
      new MutationObserver(function () {
        if (tile.parentNode === grid && tile !== grid.lastElementChild) pin();
      }).observe(grid, { childList: true });
    }
    function reveal() { tile.removeAttribute('hidden'); pin(); endPin(); }

    if (morePages()) {
      // Infinite scroll still has pages to load — keep the tile hidden until they're all in.
      tile.setAttribute('hidden', '');
      var ajax = document.querySelector('#CollectionAjaxContent') || grid;
      new MutationObserver(function (records, obs) {
        if (!morePages()) { obs.disconnect(); reveal(); }
      }).observe(ajax, { childList: true, subtree: true });
    } else {
      reveal();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCtaTile);
  } else {
    initCtaTile();
  }
})();

/* PDP desktop media grid: keep the carousel from taking over the grid gallery.
   The theme is meant to skip Flickity in grid mode, but a matchMedia timing race
   means it intermittently builds the carousel anyway on a cold load — and Flickity
   boots with zero-width cells, so its viewport is height:0 with overflow:hidden and
   CLIPS the whole gallery ("images load, then disappear"). Fix: tear that Flickity
   down so the grid CSS lays every image out. Two hard-won details:
   - Gate on window.innerWidth, NOT matchMedia: matchMedia is the same racy signal
     the theme trips on, so a matchMedia-gated guard skips at the exact moment it's
     needed. innerWidth is reliable.
   - If the instance can't be reached to destroy it, dispatch a single resize so
     Flickity re-measures and at least un-collapses into a usable carousel (never a
     blank gallery). Runs document-level so it survives late re-renders. */
(function () {
  var resizeNudged = false;
  function isDesktop() { return window.innerWidth >= 769; }
  function fixGridGallery() {
    if (!isDesktop()) return; // desktop only; mobile keeps the carousel
    var galleries = document.querySelectorAll('.product__photos--desktop-grid .product-slideshow.flickity-enabled');
    if (!galleries.length) return;
    var stillActive = false;
    galleries.forEach(function (ss) {
      var inst = (window.Flickity && window.Flickity.data) ? window.Flickity.data(ss) : null;
      if (inst && typeof inst.destroy === 'function') { try { inst.destroy(); } catch (e) {} }
      var wrap = ss.closest('[data-product-images]');
      if (wrap) { wrap.dataset.hasSlideshow = 'false'; }
      if (ss.classList.contains('flickity-enabled')) { stillActive = true; }
    });
    // Couldn't tear it down — nudge Flickity to re-measure so a clipped 0-height
    // viewport un-collapses. Once only, to avoid a resize<->observer loop.
    if (stillActive && !resizeNudged) {
      resizeNudged = true;
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }
  }
  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () { scheduled = false; fixGridGallery(); });
  }
  function start() {
    if (!document.querySelector('.product__photos--desktop-grid')) return; // grid-mode PDPs only
    fixGridGallery();
    new MutationObserver(schedule).observe(document.documentElement, {
      subtree: true, childList: true, attributes: true, attributeFilter: ['class']
    });
    [0, 150, 400, 800, 1500, 3000].forEach(function (d) { setTimeout(fixGridGallery, d); });
    window.addEventListener('load', fixGridGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
